/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  Overrides,
  BytesLike,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { OHMMagician, OHMMagicianInterface } from "../OHMMagician";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "_quote",
        type: "address",
      },
      {
        internalType: "contract IOlympusStakingV3Like",
        name: "_olympusStakingV3",
        type: "address",
      },
      {
        internalType: "contract IBalancerVaultLike",
        name: "_balancerVault",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "_balancerOhmPool",
        type: "bytes32",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "InvalidAsset",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidBalancerPool",
    type: "error",
  },
  {
    inputs: [],
    name: "BALANCER_OHM_POOL",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "BALANCER_VAULT",
    outputs: [
      {
        internalType: "contract IBalancerVaultLike",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "OHM",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "QUOTE",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "SWAP_AMOUNT_IN_LIMIT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "SWAP_AMOUNT_OUT_LIMIT",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "towardsAsset",
    outputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "quoteSpent",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256",
      },
    ],
    name: "towardsNative",
    outputs: [
      {
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IBalancerVaultLike",
        name: "_balancerVault",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "_poolId",
        type: "bytes32",
      },
    ],
    name: "verifyPoolAndVault",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

type OHMMagicianConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: OHMMagicianConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class OHMMagician__factory extends ContractFactory {
  constructor(...args: OHMMagicianConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
    this.contractName = "OHMMagician";
  }

  deploy(
    _quote: string,
    _olympusStakingV3: string,
    _balancerVault: string,
    _balancerOhmPool: BytesLike,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<OHMMagician> {
    return super.deploy(
      _quote,
      _olympusStakingV3,
      _balancerVault,
      _balancerOhmPool,
      overrides || {}
    ) as Promise<OHMMagician>;
  }
  getDeployTransaction(
    _quote: string,
    _olympusStakingV3: string,
    _balancerVault: string,
    _balancerOhmPool: BytesLike,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _quote,
      _olympusStakingV3,
      _balancerVault,
      _balancerOhmPool,
      overrides || {}
    );
  }
  attach(address: string): OHMMagician {
    return super.attach(address) as OHMMagician;
  }
  connect(signer: Signer): OHMMagician__factory {
    return super.connect(signer) as OHMMagician__factory;
  }
  static readonly contractName: "OHMMagician";
  public readonly contractName: "OHMMagician";
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): OHMMagicianInterface {
    return new utils.Interface(_abi) as OHMMagicianInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): OHMMagician {
    return new Contract(address, _abi, signerOrProvider) as OHMMagician;
  }
}
